import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EVENT_BUS } from '@shared/domain/tokens/event-bus.token';
import { ServiceSelectionChangedEvent } from '@platform/event-bus/domain/events/service-selection-change.event';
import { PermissionStore } from '../../application/stores/permission.store';

@Injectable({ providedIn: 'root' })
export class PermissionOnWorkerChangedSubscriber {
  private readonly eventBus = inject(EVENT_BUS);
  private readonly destroyRef = inject(DestroyRef);
  private readonly permissionStore = inject(PermissionStore);

  constructor() {
    this.eventBus.ofType(ServiceSelectionChangedEvent).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((event) => {
      const worker = event.payload?.worker;

      if (worker?.permissions) {
        this.permissionStore.setCurrentWorkerPermissionIds(worker.permissions);
      } else {
        this.permissionStore.setCurrentWorkerPermissionIds([]);
      }
    });
  }
}
